import React, { useState } from 'react';
import './Section.css';
import './Experience.css';

const experiences = [
  {
    id: 'thapar-research',
    company: 'Thapar SLAS',
    role: 'Research Fellow',
    period: 'Jan 2026 – Present',
    type: 'Research',
    bullets: [
      'Researching and developing Kaithi language OCR using Tesseract, enhancing automated text recognition for underrepresented scripts.',
      'Contributing to diverse client and research projects — voicebots, website development, and applied computational linguistics initiatives.',
    ],
    tags: ['Tesseract', 'OCR', 'NLP', 'Python'],
  },
  {
    id: 'mospi',
    company: 'MoSPI, Govt. of India',
    role: 'Research Fellow',
    period: 'Apr 2025 – Present',
    type: 'Research',
    bullets: [
      'Developed an ensemble ML pipeline (XGBoost, CatBoost, LightGBM) to predict monthly per capita expenditure, utilizing Optuna for hyperparameter tuning and Isolation Forest for outlier detection.',
      'Engineered socio-economic features from HCES household data to derive actionable insights, contributing to data-driven policy research.',
    ],
    tags: ['XGBoost', 'CatBoost', 'LightGBM', 'Optuna', 'Python'],
  },
  {
    id: 'toss',
    company: 'TOSS',
    role: 'Software Engineer Intern',
    period: 'Jun 2023 – Present',
    type: 'Industry',
    bullets: [
      'Architected "Heartbeat," an NLP-driven sentiment analysis pipeline for call recordings integrating a CQS (Call Quality Score) framework to quantify agent performance and customer satisfaction.',
      'Developed end-to-end dynamic voicebots for ICICI and UltraTech, engineering scalable audio pipelines with Mu-law to S16LE conversion, speech-to-text, and LLM-powered APIs for real-time intent analysis.',
    ],
    tags: ['NLP', 'LLM APIs', 'FastAPI', 'Speech-to-Text', 'Python'],
  },
  {
    id: 'evex',
    company: 'EvexFitness AI LLP',
    role: 'CEO & Founder',
    period: 'Apr 2024 – Oct 2024',
    type: 'Startup',
    bullets: [
      'Directed a 20-member interdisciplinary team to build a full-stack fitness-tech platform using React, Next.js, and GCP — overseeing the entire lifecycle from prototype to production.',
      'Integrated Computer Vision (OpenCV, MediaPipe) and custom ML models to deliver real-time AI-based posture correction and exercise tracking, significantly enhancing user engagement.',
    ],
    tags: ['React', 'Next.js', 'GCP', 'OpenCV', 'MediaPipe', 'ML'],
  },
];

export default function Experience() {
  const [active, setActive] = useState(0);
  const exp = experiences[active];

  return (
    <section id="experience" className="section">
      <div className="section-inner">
        <div className="section-header">
          <span className="section-num">02.</span>
          <h2 className="section-title">experience</h2>
          <div className="section-line" />
        </div>

        <div className="exp-layout">
          <div className="exp-tabs">
            {experiences.map((e, i) => (
              <button
                key={e.id}
                className={`exp-tab ${active === i ? 'active' : ''}`}
                onClick={() => setActive(i)}
              >
                <span className="tab-company">{e.company}</span>
                <span className="tab-type">{e.type}</span>
              </button>
            ))}
          </div>

          <div className="exp-content">
            <div className="exp-header">
              <div>
                <h3 className="exp-role">{exp.role}</h3>
                <div className="exp-company-name">
                  @ <span>{exp.company}</span>
                </div>
              </div>
              <div className="exp-period">{exp.period}</div>
            </div>

            <ul className="exp-bullets">
              {exp.bullets.map((b, i) => (
                <li key={i}>
                  <span className="bullet-arrow">▸</span>
                  {b}
                </li>
              ))}
            </ul>

            <div className="exp-tags">
              {exp.tags.map(t => (
                <span key={t} className="tag">{t}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
